import { render } from "./ActionPromotionForm.vue?vue&type=template&id=7c20948f"
import script from "./ActionPromotionForm.vue?vue&type=script&lang=js"
export * from "./ActionPromotionForm.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__